// extracted by mini-css-extract-plugin
module.exports = {"title":"App_title__1sOMD","copy":"App_copy__32QpE"};